import React, { useEffect, useRef } from 'react';
import { Link, useLocation } from 'wouter';


const BackButton = ({prevLocation}) => {

  return <Link to={prevLocation ? prevLocation : '/' } className="border block rounded-md bg-grey-400 px-3 py-2 mr-2 text-center text-sm font-semibold text-grey-800 shadow-sm hover:bg-grey-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-grey-600">Torna indietro</Link>;
}

export default BackButton;
